module.exports = __webpack_public_path__ + "x3.no1.912d533d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/x3.no1.jpg
// module id = VP9g
// module chunks = 0